export const WHATSAPP_NUMBER = "+39 377 347 3022";
export const WHATSAPP_DIGITS = WHATSAPP_NUMBER.replace(/\D/g, "");

export const whatsappLink = (text) =>
  `https://wa.me/${WHATSAPP_DIGITS}${text ? `?text=${encodeURIComponent(text)}` : ""}`;
